module.exports = __webpack_public_path__ + "static/media/row-3.d2728606.jpg";